/**
 * Created by tdunham on 6/26/2017.
 */

import {HttpClient, HttpHeaders, HttpParams}            from "@angular/common/http";
import {Injectable}                         from "@angular/core";

import {AngularQuery}                       from "../query/angularquery";
import {News}                               from './news';
import {NewsFeed}                           from "./newsfeed";

import {isNullOrUndefined}                  from "util";
import {map}                                from "rxjs/operators";
import {Observable}                         from "rxjs";


/**
 * Handle queries to the "news" database and its related databases.
 */
@Injectable()
export class NewsService {

	/**
	 * Initialize the object.
	 *
	 * @constructor
	 */
	constructor(

		protected http: HttpClient

	) {}


	/**
	 * Move an item to the Trash.
	 *
	 * @param {number} id  The news table ID value of the item to delete.
	 * @return {Observable<any>} Return any response.
	 */
	deleteItem(id: number): Observable<any> {

		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_NEWS, String(id));
		query.useParams(false);

		return this.http
			.delete<any>(query.getUrl());

	}


	/**
	 * Get an array of NewsFeed objects as an Observable.
	 *
	 * @param {string} url           The URL to retrieve.
	 * @returns {any}  An array of NewsFeed objects or an error.
	 */
	getNewsFeedItems(url: string): Observable<NewsFeed[]> {

		return this.http
			.get<NewsFeed[]>(url);

	}


	/**
	 * Get the specified News object based on its ID
	 * value in the Angular ReST API "news" table.
	 *
	 * @param {int} id  The News object to retrieve or 'new', if it's a new article.
	 * @returns {Observable<News>} An Observable with the News object or the error string.
	 */
	getNewsItem(id: string): Observable<News> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_NEWS, id);
		query.useParams(false);
		let url:string = query.getUrl();

		return this.http
			.get<News>(url);

	}


	/**
	 * Get an array of News objects as an Observable.
	 *
	 * @param {string} url           The URL to retrieve.
	 * @returns {any}  An array of News objects or an error.
	 */
	getNewsItems(url: string): Observable<News[]> {

		return this.http
			.get<News[]>(url, { withCredentials: true });

	}

	searchNewsItems(searchParameters: {sort_order?: string, code?: string, startdate?: string, enddate?: string, player_id?: number, team_id?:number, source_id?:number, user_id?: number}, rowcount: number = 10, offset: number = 0){
		let query: AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_NEWS_SEARCH);       // Select the table to search.	
		//query.setPerPage(10);
		query.useParams(false);
		query.addParameter('rowcount', rowcount.toString());
		query.addParameter('offset', offset.toString());

		Object.keys(searchParameters).forEach(
			(key) => {
				query.addParameter(key, searchParameters[key].toString());
			}
		)

		let url = query.getUrl();
		return this.http.get<News[]>(url, { withCredentials: true })
	}


	/**
	 * Post to the News and associated tables the
	 * information supplied in the Object.
	 *
	 * @param {string} url   The URL of the post.  Will contain 'new' or the existing post ID value.
	 * @param {string} json  The article content as a JSON string.
	 * @returns {Observable<any>} The revised post ID if the post is successful, an error response otherwise.
	 */
	postNewsItem(url: string, json: string): Observable<any> {

		let headers = new HttpHeaders();
		headers = headers.append('Content-Type', 'application/json');

		return this.http
			.post<any>(url, json, { headers: headers })
			.pipe(
				map((response:any) => {

					let post: News = new News(response);

					if (Number.isInteger(post.id)) {

						return post.id;

					}

					return -1;

				})
			);

	}


	/**
	 * Ask the server to parse the provided JSON and return
	 * the results for display.
	 *
	 * @param url   The URL for the request.
	 * @param json  The JSON string to be passed to the server.
	 * @returns {Observable<any>}  An Object with returned data or an error.
	 */
	postParseRequest(url: string, json: string): Observable<any> {

		let headers = new HttpHeaders().append('Content-Type', 'application/json');

		return this.http
			.post<any>(url, json, { headers: headers })
			.pipe(
				map((response) => {

					let preview: Object = response;

					if (isNullOrUndefined(preview['article'])) {

						let err: Object = {};
						err['article'] = 'An error occurred while creating the preview.';
						err['tags'] = [];
						err['players'] = [];
						err['team'] = {};
						err['valid'] = false;
						return err;

					} else {

						preview['valid'] = true;
						return preview;

					}

				})
			);

	}

}


// WEBPACK FOOTER //
// ./src/app/services/news/news-service.ts